// extracted by mini-css-extract-plugin
export default {"spacingXXS":"4px","spacingXSSM":"6px","spacingXS":"8px","spacingSM":"12px","spacing":"16px","spacingMD":"20px","spacingLG":"24px","spacingXL":"32px"};